module.exports = __webpack_public_path__ + "img/about-header.326e439.svg";